export default __webpack_public_path__ + "static/media/alekhine.80db6f68.txt";